import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { SetEnrollmentDataPdf } from '../../models/set-enrollment-data-pdf'
import { EnrollmentData } from '../../models/enrollment-data'

import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'DataEntryStep5',
    templateUrl: 'data-entry-step5.html'
})
export class DataEntryStep5Component implements OnInit {
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    confirmationNumber: string
    showUpdatesSettingsMessage = 'Success'
    setPdf: SetEnrollmentDataPdf = {} as SetEnrollmentDataPdf
    enrollmentJson: EnrollmentData
    selectedPlanYear: number

    constructor(private router: Router, private _enrollementGateway: EnrollmentGateway, public _global: PortalGlobals) {
        this.enrollment = {} as EnrollmentViewModel
        this.setPdf = {} as SetEnrollmentDataPdf
    }

    ngOnInit() {
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        sessionStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))
        localStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)
        if (this.enrollment !== undefined && this.enrollment.CONF !== undefined) {
            this.confirmationNumber = this.enrollment.CONF
        }
        if (this.enrollment !== undefined && this.enrollment !== null) {
            this.SendEmailOnConfirmation(this.enrollment.PLANTYPENAME)
        }

        //Remove session object for enrollment cache
        if (sessionStorage.getItem('EnrollmentCache') != null) {
            sessionStorage.removeItem('EnrollmentCache')
        }
    }

    enrollNew(): void {
        this.enrollment = {} as EnrollmentViewModel
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step1'])
    }

    SendEmailOnConfirmation(planname: string): void {
        this._enrollementGateway.SendEmailOnConfirmation(planname).subscribe(() => (this.showUpdatesSettingsMessage = 'Success'))
    }

    SavePdf(): void {
        //if (this.enrollment.EOB !== undefined) {
        //    //if (this.enrollment.EOB.toString().toUpperCase() === 'EEOB') {
        //    if (this.enrollment.EOB === '3') {
        //        this.enrollment.EOB = 'Yes'
        //    } else {
        //        this.enrollment.EOB = 'No'
        //    }
        //}
        //else {
        //    this.enrollment.EOB = ''
        //}
        if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== null)
            this.selectedPlanYear = this._global.selectedPlanYear
        else this.selectedPlanYear = 2021

        this._enrollementGateway
            .generatePDF(this.enrollment, this._global.currentUser.insuranceCompanyName, this.selectedPlanYear)
            .subscribe((model: any) => {
                console.log(model)
                var binaryString = window.atob(model)
                var binaryLen = binaryString.length
                console.log('binaryLen' + binaryLen)
                if (binaryLen == 3) {
                    console.log('File doesnt exist / some back ground  error')
                    // this.downloadError = 'File Not Found'
                    return
                }
                // this.downloadError = ''
                var bytes = new Uint8Array(binaryLen)
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i)
                    bytes[i] = ascii
                }

                let fileName = this.enrollment.APPLN + '-' + this.enrollment.APPFN + '.pdf'
                // below code needed for ie browser
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    ;(window.navigator as any).msSaveBlob(new Blob([bytes], { type: 'application/pdf' }), fileName)
                }
                // for other browsers
                var fileURL = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
                // window.open(fileURL)
                var link = document.createElement('a')
                link.setAttribute('href', fileURL)
                link.setAttribute('download', fileName)
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
    }

    printHardCopy(): void {
        /*this._enrollementGateway.printEnrollmentPDF(this.enrollment).subscribe(
            (model: any) => {
                console.log(model)
                var binaryString = window.atob(model)
                var binaryLen = binaryString.length;
                console.log('binaryLen' + binaryLen)
                if (binaryLen == 3) {
                    console.log('File doesnt exist / some back ground  error')
                    return
                }
                var bytes = new Uint8Array(binaryLen)
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i)
                    bytes[i] = ascii
                }
                let fileName = ""
                // below code needed for ie browser
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    console.log('user clickedon ie browser')
                    window.navigator.msSaveOrOpenBlob(new Blob([bytes],
                        { type: 'application/json' }), fileName)
                }
                // for other browsers
                var fileURL = URL.createObjectURL(new Blob([bytes], { type: 'application/json' }))
                window.open(fileURL, '_blank').print()
                // window.print()
            }
        )*/
        this.router.navigate(['/enrollment/print'])
    }
}
